__turbopack_context__.v({
  "root": "IdFormatter-module__F2kIja__root",
});
